import { render } from "./PermissionsView.vue?vue&type=template&id=4795fc1e&scoped=true"
import script from "./PermissionsView.vue?vue&type=script&lang=js"
export * from "./PermissionsView.vue?vue&type=script&lang=js"

import "./PermissionsView.vue?vue&type=style&index=0&id=4795fc1e&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4795fc1e"]])

export default __exports__